import React from 'react'
import {actions as salesActions, selectors as salesSelectors} from '../../../Ducks/sales';
import {selectors as accountSelectors} from '../../../Ducks/account';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import GridElement from '../../Common/GridElement';
import {Button} from '@mui/material';
import EditTable from '../../Common/EditTable';
import {cloneDeep, isEmpty} from 'lodash';
import {makeAccessor, makeHeader, prepareFilterQuery, prepareSortQuery} from "../../Utils/gridUtils";
import {getSales} from "../../../API/sales";

const SalesGrid = (props) => {
    const {navigate} = props;
    const [data, setData] = React.useState([]);
    const [loading, setLoading] = React.useState(false);
    const [pageCount, setPageCount] = React.useState(0);
    const [rowsCount, setRowsCount] = React.useState(0);
    const [filters, setFilters] = React.useState([]);
    const [controlledPageIndex, setControlledPageIndex] = React.useState(0);
    const [isOpen, setIsOpen] = React.useState(false);
    const [cols, setCols] = React.useState(JSON.parse(localStorage.getItem("user")).tableSettings.purchases.columns.map(key => ({
        column: key,
        accessor: makeAccessor(key),
        minWidth: 150,
        Header: makeHeader(key),
        filter: 'fuzzyText'
    })));
    const fetchIdRef = React.useRef(0);

    const fetchData = React.useCallback(({pageSize, pageIndex, sortBy, filters, columns}) => {
        // This will get called when the table needs new data
        // You could fetch your data from literally anywhere,
        // even a server. But for this example, we'll just fake it.

        // Parse columns
        const _columns = columns.map((item) => item.column);
        _columns.push("opportunity_id");

        // Give this fetch an ID
        const fetchId = ++fetchIdRef.current

        // Set the loading state
        setLoading(true)

        let query = prepareFilterQuery(filters, columns, "purchases");
        let sort = prepareSortQuery(sortBy, columns);

        getSales({
            results: pageSize,
            columns: _columns,
            offset: pageIndex + 1,
            filter: query,
            sort: sort
        }).then((purchases) => {
            if (fetchId === fetchIdRef.current && purchases) {
                const _purchases = cloneDeep(purchases);
                const jobs = purchases.data.related_objects["jobs"]
                const products = purchases.data.related_objects["products"]
                const users = purchases.data.related_objects["users"]
                const opportunities = purchases.data.related_objects["opportunities"]

                if (!isEmpty(purchases.data.related_objects)) {
                    _purchases.data.main.forEach((purchase) => {
                        if (products && !isEmpty(products[purchase.product_id])) {
                            const _product_obj = cloneDeep(products[purchase.product_id])
                            delete _product_obj["product_id"]
                            Object.assign(purchase, _product_obj);
                        }

                        if (jobs && !isEmpty(jobs[purchase.job_id])) {
                            const _job_obj = cloneDeep(jobs[purchase.job_id])
                            delete _job_obj["job_id"]
                            Object.assign(purchase, _job_obj);
                        }

                        if (users && !isEmpty(users[purchase.user_id])) {
                            const _user_obj = cloneDeep(users[purchase.user_id])
                            delete _user_obj["user_id"]
                            Object.assign(purchase, _user_obj);
                        }

                        if (opportunities && !isEmpty(opportunities[purchase.opportunity_id])) {
                            const _opportunity_obj = cloneDeep(opportunities[purchase.opportunity_id])
                            delete _opportunity_obj["opportunity_id"]
                            Object.assign(purchase, _opportunity_obj);
                        }
                    });
                }

                setData(_purchases.data.main);
                setPageCount(purchases.data.offset.highest_offset);
                setRowsCount(purchases.data.offset.rows_count);
                setLoading(false);
            }
        }).catch((_error) => {
            setLoading(false);
        });
    }, []);

    const resetFilters = React.useCallback(() => setFilters([]), [setFilters]);

    const handleRowClick = (row) => {
        navigate("/sales/id/" + row.original.purchase_id);
    }

    const handleClose = () => {
        setIsOpen(false);
    }

    return (
        <>
            <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                <h2 className="page-title">Sales</h2>
                <Button variant="outlined" color='primary' onClick={() => setIsOpen(true)}>Edit Table</Button>
            </div>

            <GridElement
                columns={cols}
                data={data}
                fetchData={fetchData}
                loading={loading}
                pageCount={pageCount}
                controlledPageIndex={controlledPageIndex}
                setControlledPageIndex={setControlledPageIndex}
                filters={filters}
                setFilters={setFilters}
                resetFilters={resetFilters}
                rowsCount={rowsCount}
                handleRowClick={handleRowClick}
                initialSortBy="purchase_id"
            />

            <EditTable
                open={isOpen}
                onClose={handleClose}
                columns={["purchases", "opportunities", "products", "jobs", "users"]}
                table="purchases"
                setColumns={setCols}
            />
        </>
    )
}

const mapStateToProps = (state) => ({
    isLoading: salesSelectors.isLoading(state),
    errorMessage: salesSelectors.errorMessage(state),
    sales: salesSelectors.sales(state),
    user: accountSelectors.user(state),
});

const mapDispatchToProps = (dispatch) => bindActionCreators(
    {
        getSales: salesActions.getSales,
    },
    dispatch);

function WithNavigate(props) {
    let navigate = useNavigate();
    return <SalesGrid {...props} navigate={navigate}/>
}

export default connect(mapStateToProps, mapDispatchToProps)(WithNavigate);